// l10n status: n/a
import { CreateComponent } from "components/utils/CreateComponent"
import { rootStore } from "store/RootStore"
import directorBadge from "img/player/director_small.png"
import personSvg from "img/player/person.svg"
import { CALLING_CONTEXT_TYPE } from "store/page/OverlayEventDetails"
import { useState, useEffect } from "react"
//import { getPersonPicture } from "store/tmdb/Tmdb.js"
import { analyticsScreen, analyticsMeta } from "store/qlapi/LogService"
import { BrokerEventPersonRole } from "@quickline/coco"
import { eventId } from "utils/EventHelpers"
//import "velocity-animate/velocity.ui.min.js"

import "./../Overlay/OverlayEventDetails.css"

// MTVW-931: moved from obsolete PersonCarousel
export const PersonTile = CreateComponent(null, false, true, ({ isDragging, page, oEventData, item, nbItems, ix, origin, callingContext = CALLING_CONTEXT_TYPE.keepOldContext, resetOverlay = () => { } }) => {
	const [firstTileMarginLeft, setFirstTileMarginLeft] = useState(0)
	const [pictureUrl, setPictureUrl] = useState(null)
	//console.debug("personItem", origin, rootStore.page.Discover.firstTileMarginLeft[origin], rootStore.page.Discover.firstTileMarginLeft, item)

	useEffect(() => {
		// MTVW-931
		setFirstTileMarginLeft(rootStore.page.Discover.firstTileMarginLeft[origin])
		/* MTVW-1075: picture url from CoCo
		getPersonPicture(item.actor).then((res) => {
			setPictureUrl(res)
		})
		*/
		return () => {
		}
		// MTVW-1027: add dependencies, otherwise wrong picture might be shown
	}, [item.name, item.profileUrl, origin])

	useEffect(() => {
		if (rootStore.page.Discover.firstTileMarginLeft[origin] !== firstTileMarginLeft) setFirstTileMarginLeft(rootStore.page.Discover.firstTileMarginLeft[origin])
	}, [rootStore.page.Discover.firstTileMarginLeft[origin]])

	return (
		<div className="personTile" style={{
			marginLeft: ix === 0 ? firstTileMarginLeft + "px" : 0,
			// doesn't work only on Safari! Use paddingRight instead
			//marginRight: ix === nbItems - 1 ? firstTileMarginLeft + "px" : 0,
			paddingRight: ix === nbItems - 1 ? firstTileMarginLeft + "px" : 0
		}}>
			<div className="personImageContainer"
				onClick={(e) => {
					e.stopPropagation()
					if (!isDragging) {
						//console.debug("isDragging=", isDragging)
						// no back button if in LiveTv
						//if (rootStore.page.Player.isPlayerOnOverlay) {
						if (rootStore.page.OverlayEventDetails.isVisible) {
							rootStore.page.OverlayEventDetails.pushActivity({ type: 'related', id: eventId(oEventData) })
						}
						rootStore.logService.analyticsScreenview({ [analyticsMeta.screen]: analyticsScreen.personRelatedPrograms, person: item.name })
						rootStore.page.OverlayEventDetails.setActorName(item.name).setComponentType(rootStore.page.Search.CATEGORY_ACTORS).setShow(true, CALLING_CONTEXT_TYPE.TvGuide)
						// MTVW-1040: make sure that cover is loaded in EventComponent
						rootStore.page.OverlayEventDetails.setIsPlayerPresent(false)
					}
				}}
			>
				<div className="personEllipse1" />
				{item.profileUrl ?
					<img loading="lazy" className="personImage" src={item.profileUrl} />
					:
					<img loading="lazy" className="personImageSvg" src={personSvg} />
				}
				<div className="personEllipse2" />
			</div>
			{item.role === BrokerEventPersonRole.Director ?
				<div className="directorBadgeContainer">
					<div className="directorEllipse" />
					<div className="directorMaskGroup">
						<img loading="lazy" className="directorBadgeLogo" src={directorBadge} />
						<div className="directorRectangle" />
					</div>
				</div>
				: <></>
			}
			<div className="personName">{item.name}</div>
		</div>
	)
})
